import { useTagsQuery } from './enrollment-types';

export const useMissedAppsTagId = () => {
  const {data} = useTagsQuery();
  return data?.tags.find(t => t.name.toLowerCase().includes('missed'))?.id;
}
